import React from 'react';
import { CustomTextField } from '../../../../widgets/CustomTextField';
import { EntityForm } from '../../../../widgets/Forms';
import ViewUtils from '../../../../ViewUtils';
import TabPanel from '../../../../widgets/TabPanel';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import { LookupField } from '../../../../widgets/LookupField';
import Table from '@material-ui/core/Table';
import { SelectItem } from '../../../../widgets/SelectItem';
import { CustomDatePicker } from '../../../../widgets/CustomDatePicker';
import QualificationSearch from '../../Controls/QualificationsSearch';
import InstitutionSearch from '../../Controls/InstitutionSearch';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const utils = new ViewUtils();

const styles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            minWidth: 50,
            textAlign: 'center',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        minWidth: 200
    },
    inputForm: {
        minWidth: '200px',
    },
    table: {
        minWidth: 700,
    },
    inputCenter: {
        textAlign: 'center'
    },
    paper: {
        position: "absolute",
        width: 600,
        height: 450,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(0.1)
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#D9B262',
        color: theme.palette.common.white,
        border: '1px solid white',
        height: 6
    },
    body: {
        fontSize: 11,
    },

}))(TableCell);

const StyledTableTextCell = withStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            // width: 50,
            textAlign: 'center'
        },
    },
    body: {
        fontSize: 14,
        fontWeight: 500
    }

}))(TableCell);


const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
            height: theme.palette.action.main
        },
    },
}))(TableRow);

export const ShortCourseForm = React.forwardRef((props, ref) => {
    const [tabValue, setTabValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    function GetProvinceID(value) {
        //console.clear();
        //console.log(value);
        if (value !== undefined && value !== null) {
            return value.Id
        }
        else {
            return "0"
        }
    }

    return (
        <EntityForm
            ref={ref}
            viewId={null}
            values={props.data}
            entityLookupController={props.entityLookupController}
            org="saseta"
            entityLookupId={props.id}
            useCustomSettings={false}
            dataArrivedHandler={props.dataArrivedHandler} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="Bursary">
                    <div className="row w-100">
                        <div className="col w-100">
                            <TabPanel value={tabValue} index={0} className=''>
                                <table cellPadding="2" width="80%">
                                    <tbody>

                                        <tr>
                                            <td width="50%">
                                                <CustomTextField
                                                    id="QualificationTitle"
                                                    key={tabValue}
                                                    label="Short Course Name"
                                                    className="w-100"
                                                    InputProps={{
                                                        readOnly: false,
                                                    }}
                                                    form={form}
                                                    //required
                                                />
                                            </td>
                                            <td width="50%">
                                                <SelectItem
                                                    dataUrl={'api/sims/DGApplicationForms2027/GetLookupListDGERRPOFOCode?parameter=[{"Name":"DGApplicationID","Value":' + props.DGApplicationID + '}]'}
                                                    id="DGERRPOFOCodeID"
                                                    key={tabValue}
                                                    label="ERRP OFO Code"
                                                    className="w-100"
                                                    form={form}
                                                    allowEmptyValue={true}
                                                    //required
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="50%">
                                                <CustomTextField
                                                    id="NumberLearners"
                                                    key={tabValue}
                                                    label="Number Of Learners"
                                                    className="w-100"
                                                    InputProps={{
                                                        readOnly: false,
                                                    }}
                                                    form={form}
                                                    validationRegex={/^[0-9]+$/g}
                                                    //required
                                                />
                                            </td>
                                            <td width="50%">
                                                <CustomTextField
                                                    id="TuitionFees"
                                                    key={tabValue}
                                                    label="Anticipated Training Cost per Learner"
                                                    className="w-100"
                                                    InputProps={{
                                                        readOnly: false,
                                                    }}
                                                    form={form}
                                                    validationRegex="^[0-9]+(\.[0-9]{1,2})?$"
                                                    //required
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="50%">
                                                <CustomDatePicker
                                                    id="StartDate"
                                                    label="Start Date"
                                                    className='w-100'
                                                    //required
                                                    form={form}
                                                />
                                            </td>
                                            <td width="50%">
                                                <CustomDatePicker
                                                    id="EndDate"
                                                    label="End Date"
                                                    className='w-100'
                                                    //required
                                                    form={form}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <CustomTextField
                                                    id="ContactPerson"
                                                    key={tabValue}
                                                    parentId={0}
                                                    label="Contact Person"
                                                    className="w-100"
                                                    form={form}
                                                    //required
                                                />
                                            </td>
                                            <td>
                                                <CustomTextField
                                                    id="CellPhoneNumber"
                                                    //required
                                                    parentId={0}
                                                    key={tabValue}
                                                    label="Cell Phone Number"
                                                    validationRegex="^$|\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$"
                                                    className='{classes.textField} w-100'
                                                    form={form}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <CustomTextField
                                                    id="EMail"
                                                    //required
                                                    parentId={0}
                                                    key={tabValue}
                                                    label="E Mail"
                                                    validationRegex="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                                                    className='{classes.textField} w-100'
                                                    form={form}
                                                />
                                            </td>
                                            <td>
                                                <CustomTextField
                                                    id="RegistrationCategory"
                                                    key={tabValue}
                                                    label="Training Platform Name"
                                                    className="w-100"
                                                    InputProps={{
                                                        readOnly: false,
                                                    }}
                                                    form={form}
                                                    //required
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <SelectItem
                                                    dataUrl="api/sims/DGApplicationForms2027/GetLookupList?listId=Province"
                                                    id="ProvinceID"
                                                    key={tabValue}
                                                    onChange={props.onChangeProvinceIDHandler}
                                                    label="Province"
                                                    className="w-100"
                                                    form={form}
                                                    allowEmptyValue={true}
                                                    //required
                                                />
                                            </td>
                                            <td>
                                                <SelectItem
                                                    dataUrl={'api/sims/DGApplicationForms2027/GetDGMunicipalityByProvince?parameter=[{"Name":"ProvinceID","Value":' + GetProvinceID(form.values["ProvinceID"]) + '}]'}
                                                    id="MunicipalityID"
                                                    key={tabValue}
                                                    label="Municipality"
                                                    className="w-100"
                                                    form={form}
                                                    allowEmptyValue={true}
                                                    clearOptions={props.clearOptions}
                                                    clearOptionsHandler={props.clearOptionsHandler}
                                                    //required
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <Table className={styles.table} size="small" >
                                    <TableHead>

                                        <TableRow>
                                            <StyledTableCell align="center" colSpan={3}>African</StyledTableCell>
                                            <StyledTableCell align="center" colSpan={3}>Coloured</StyledTableCell>
                                            <StyledTableCell align="center" colSpan={3}>Indian/Asian</StyledTableCell>
                                            <StyledTableCell align="center" colSpan={3}>White</StyledTableCell>
                                        </TableRow>

                                        <TableRow>
                                            <StyledTableCell align="center" >M</StyledTableCell>
                                            <StyledTableCell align="center">F</StyledTableCell>
                                            <StyledTableCell align="center">D</StyledTableCell>

                                            <StyledTableCell align="center" >M</StyledTableCell>
                                            <StyledTableCell align="center">F</StyledTableCell>
                                            <StyledTableCell align="center">D</StyledTableCell>

                                            <StyledTableCell align="center" >M</StyledTableCell>
                                            <StyledTableCell align="center">F</StyledTableCell>
                                            <StyledTableCell align="center">D</StyledTableCell>

                                            <StyledTableCell align="center" >M</StyledTableCell>
                                            <StyledTableCell align="center">F</StyledTableCell>
                                            <StyledTableCell align="center">D</StyledTableCell>
                                        </TableRow>

                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow color="primary">
                                            <StyledTableTextCell align="center"><CustomTextField id="AfricanMale" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>
                                            <StyledTableTextCell align="center"><CustomTextField id="AfricanFemale" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>
                                            <StyledTableTextCell align="center"><CustomTextField id="AfricanDisabled" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>

                                            <StyledTableTextCell align="center"><CustomTextField id="ColouredMale" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>
                                            <StyledTableTextCell align="center"><CustomTextField id="ColouredFemale" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>
                                            <StyledTableTextCell align="center"><CustomTextField id="ColouredDisabled" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>

                                            <StyledTableTextCell align="center"><CustomTextField id="IndianMale" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>
                                            <StyledTableTextCell align="center"><CustomTextField id="IndianFemale" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>
                                            <StyledTableTextCell align="center"><CustomTextField id="IndianDisabled" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>

                                            <StyledTableTextCell align="center"><CustomTextField id="WhiteMale" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>
                                            <StyledTableTextCell align="center"><CustomTextField id="WhiteFemale" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>
                                            <StyledTableTextCell align="center"><CustomTextField id="WhiteDisabled" variant="outlined" styles={{ minWidth: "45px" }} size="small" /*required*/ validationRegex={/^[0-9]+$/g} form={form} /></StyledTableTextCell>

                                        </StyledTableRow>

                                    </TableBody>
                                </Table>
                            </TabPanel>
                        </div>
                    </div>
                </form >
            }
        </EntityForm >
    );
})